<!--
/*******************************************************************************
*@ 컴포넌트명   : PushStupPopup.vue
*@ 컴포넌트설명 : Push설정팝업
*@ 사용전문     : 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <article>
    <!-- 앱 PUSH 안내 -->
    <modal-pop
      :opened.sync="isPopupOpen"
      :modalHeader="true"
      :modalFooter="true"
      :btnClose="true"
      :titleCenter="true"
      title="MPSH-01-01-00-09"
    >
      <template #content>
        <strong class="info-question mtop-12 btm-border">
          <!-- 이 기기로 입출금, 공지사항 등을<br />PUSH 알림으로 받아보시겠습니까? -->
          {{$t("MPSH-01-01-01-01")}}
        </strong>
        <div class="desc mtop-12 mbtm-12">
          <!-- [메인 > 알림서비스 > 알림설정] 메뉴에서 알림설정을 변경하실 수있습니다. -->
          {{$t("MPSH-01-01-01-02")}}
        </div>
        <!-- notice -->
        <div class="notice -ulist-type">
          <div class="notice-tit">
            <p>
              <!-- 유의사항 -->
              {{$t("MPSH-01-01-00-01")}}
            </p>
          </div>
          <div class="notice-cont">
            <ul class="ulist bar">
              <li>
                <!-- 앱 PUSH를 동의하셨더라도 사용하시는 기기에서 동의하지 않으셨다면 이용하실 수 없습니다. -->
                {{$t("MPSH-01-01-01-03")}}
              </li>
              <li>
                <!-- 한 대의 기기에서만 PUSH 알림을 받으실 수 있습니다. -->
                {{$t("MPSH-01-01-01-04")}}
              </li>
            </ul>
          </div>
        </div>
        <!--// notice -->
      </template>
      <template #footer>
        <button class="btn bottom negative" @click="decline()">
          <!-- 아니오 -->
          {{$t("MPSH-01-01-00-05")}}
        </button>
        <button
          class="btn bottom positive"
          @click="() =>{ isPopupOpen = false, $router.push({ name: 'pushNotiStup' }) }"
        >
          <!-- 네 -->
          {{$t("MPSH-01-01-00-04")}}
        </button>
      </template>
    </modal-pop>
    <push-stup-no-popup ref="pushStupNoPopup" :opened.sync="isNoPopupOpen" />
  </article>
</template>

<script>
import PushStupNoPopup from "@/components/page/common/PushStupNoPopup";
import { mapFields } from "vuex-map-fields";
export default {
  props: ["opened"],
  components: {
    PushStupNoPopup,
  },
  mounted() {
    this.isNoPopupOpen = false;
  },
  created() {},
  data() {
    return {
      isNoPopupOpen: false,
    };
  },
  computed: {
    ...mapFields(["sessionInfo"]),
    isPopupOpen: {
      get() {
        return this.opened;
      },
      set(value) {
        this.$emit("update:opened", value);
      },
    },
  },
  methods: {
    decline() {
      this.$log.info("NO!!!!!");
      let pushNotiStupInfo = {
        pushRecvCnsntYn: "0",
        prdctCnsntYn: "0",
        anounCnsntYn: "0",
        aprvalCnsntYn: "0",
        motpAuthCnsntYn: "0",
        rcdrwCnsntYn: "0",
      };

      this.$post("/customer/notice/regPushStupInfo", pushNotiStupInfo, {}, null, () => {
        this.sessionInfo.userInfo.pushRecvCnsntYn = "0";
        this.isPopupOpen = false;
        this.isNoPopupOpen = true;
      });
    },
  },
};
</script>
